import React, { Component } from 'react';
import classNames from 'classnames';

export class CloseIcon extends Component {
    render () {
        return (
            <i className={classNames("close_icon", this.props.className)}
               onClick={this.props.onClick}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/html.js